import { Attributes } from '@leverege/ui-attributes';
import Routes from "./Routes.js";
import Redux from "./Redux.js";
import Plugins from "./Plugins.js";
import { blueprints, blueprint, relationship, relationships } from "./Blueprints.js";
export default {
  routes: Routes,
  redux: Redux,
  plugins: Plugins,
  attributes: Attributes,
  blueprints,
  blueprint,
  relationship,
  relationships,
  get molten() {
    return window.leveregeMolten?.molten;
  },
  versions: {
    ...process.env.LEVEREGE_VERSIONS
  },
  buildHash: process.env.LEVEREGE_BUILD_HASH
};